import { apiRequest } from "../utils/useAPIRequest";
import constant from "../utils/constant";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { queryClient } from "../App";

const useGetFeedback = (feedbackTableQuery, filterQuery, searchQuery) => {
  const query = useMemo(() => {
    if (searchQuery && filterQuery) {
      return `${feedbackTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (searchQuery) {
      return `${feedbackTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${feedbackTableQuery}&${filterQuery}`;
    } else {
      return feedbackTableQuery;
    }
  }, [filterQuery, feedbackTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getFeedback", query],
    queryFn: () => {
      return apiRequest({
        url: `/reviews/review-result?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const useGetFeedbackKey = (
  feedbackConfigTableQuery,
  filterQuery,
  searchQuery
) => {
  const query = useMemo(() => {
    if (searchQuery && filterQuery) {
      return `${feedbackConfigTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (searchQuery) {
      return `${feedbackConfigTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${feedbackConfigTableQuery}&${filterQuery}`;
    } else {
      return feedbackConfigTableQuery;
    }
  }, [filterQuery, feedbackConfigTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getFeedbackKey", query],
    queryFn: () => {
      return apiRequest({
        url: `/reviews/review?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const createFeedbackKey = async (payload) => {
  const { status, errorMessage, data } = await apiRequest({
    url: "/reviews/review ",
    method: "post",
    payload,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({ queryKey: ["getFeedbackKey"] });
    return { status: constant.Success, data };
  }
  return { errorMessage, status, data };
};

const updateFeedbackStatus = async (payload, revResultId) => {
  const { status, errorMessage } = await apiRequest({
    url: `/reviews/review-result/${revResultId}`,
    method: "patch",
    payload,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({ queryKey: ["getFeedback"] });

    return { status };
  }
  return { status, errorMessage };
};

const updateFeedbackKeys = async (payload, revResultId) => {
  const { status, errorMessage } = await apiRequest({
    url: `/reviews/review/${revResultId}`,
    method: "patch",
    payload,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({ queryKey: ["getFeedbackKey"] });
    return { status };
  }
  return { status, errorMessage };
};

const FeedbackController = {
  createFeedbackKey,
  updateFeedbackStatus,
  updateFeedbackKeys,
  useGetFeedback,
  useGetFeedbackKey,
};

export default FeedbackController;
